function roundToNearestTenth(value: number): number {
  return Math.round(value * 10) / 10;
}

export { roundToNearestTenth };
